module.exports = __webpack_public_path__ + "img/1.c3828aa1.jpg";